'use strict';

class PosSlide {
	constructor(el) {
		this.$slide = $(el);
		this.$slideContainer = this.$slide.find('.js_posslide_container');
		this.$pagination = this.$slide.find('.js_posslide_dot');
		this.$slideThumbnail = this.$slide.find('.js_posslide_thumbnail');
		this.swiper = null;
		this.init();
	}

	init() {
		// if (window.innerWidth <= 1023) {
			this.build();
		// }
	}

	build() {
    // サムネイル
    const sliderThumbnail = new Swiper(this.$slideThumbnail[0], { // [0]でDOM要素を渡す
        slidesPerView: 4,
        watchSlidesProgress: true, // 追加
    });

    this.swiper = new Swiper(this.$slideContainer[0], { // [0]でDOM要素を渡す
        fade: false,
        spaceBetween: 30,
        slidesPerView: 'auto',
        centeredSlides: true,
        autoHeight: true,
        simulateTouch: true,
        speed: 1000,
        navigation: {
            nextEl: this.$slide.find('.swiper-button-next')[0],
            prevEl: this.$slide.find('.swiper-button-prev')[0]
        },
        pagination: {
            el: this.$pagination[0],
            type: 'bullets',
            clickable: true,
        },
        thumbs: {
            swiper: sliderThumbnail,
        },
        watchOverflow: true,
    });
    this.swiper.init();
	}

	destroy() {
		if (this.swiper) {
			this.swiper.destroy(true, true);
			this.swiper = null;
		}
	}

	update() {
		this.build();
		// if (window.innerWidth <= 1023) {
		// 	this.build();
		// } else {
		// 	this.destroy();
		// }
	}
}

export default PosSlide;
